export default function setFormatTime(time){
  let prevDate = new Date(time)
  let newDate = new Date(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate(),prevDate.getHours(),prevDate.getMinutes(),prevDate.getSeconds())
  let prevyear = newDate.getFullYear()
  let prevmonth = (newDate.getMonth() + 1)<9?'0'+(newDate.getMonth() + 1):(newDate.getMonth() + 1)
  let prevday = (newDate.getDate())<9?'0'+(newDate.getDate()):(newDate.getDate())
  let preHours =(newDate.getHours())<9?'0'+(newDate.getHours()):(newDate.getHours())
  let preMinutes =newDate.getMinutes()<9?'0'+newDate.getMinutes():newDate.getMinutes()
  let preSeconds =newDate.getSeconds()<9?'0'+ newDate.getSeconds():newDate.getSeconds()
  let prevTime = prevyear + "-" + prevmonth + "-" + prevday+" "+preHours+':'+preMinutes+':'+preSeconds
  return prevTime
}



// WEBPACK FOOTER //
// ./src/assets/js/lib/setFormatTime.js